module.exports = __webpack_public_path__ + "img/126.61d7db6f.jpg";